module.exports = __webpack_public_path__ + "img/6.5df8b052.png";